import React from 'react';
import '../../styles/table-main/main.css';

const Main = () => {
    return (
        <div id='tableMain'>
            <div className="table-inner-main">
                <div className="container mt-5 mb-5 admin-container">
                    <div className="row">
                        <div className="col-md-12 pull-left flip sm-pull-none">
                            <div className="admin-table">
                                <h2 className="my-heading">Left Out Pratical Forms</h2>
                                <div className="table-scrollable">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr>
                                                <th>Examination Form</th>
                                                <th>Start Date</th>
                                                <th>End Date</th>
                                                <th>Apply</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        Annual Courses Reg &amp; Pvt for Examination &amp; Leftout
                                                        Examination Form <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://annual.ccsuniversityweb.in"
                                                            target="_blank"
                                                            className="apply"
                                                            rel="noreferrer"
                                                        >
                                                            {" "}
                                                            Apply Now
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <span style={{ color: "#036" }}>
                                                        Semester Courses Leftout Examination Form <span />
                                                    </span>
                                                </td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">--</td>
                                                <td className="text-center">
                                                    <button className="btn btn-primary btn-download">
                                                        <a
                                                            href="https://ccsuniversityweb.in/"
                                                            target="_blank"
                                                            className="apply"
                                                            rel="noreferrer"
                                                        >
                                                            {" "}
                                                            Apply Now
                                                        </a>
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Main;